import * as THREE from 'three';
import { TILE_SIZE } from '../../labyrinth/Labyrinth';
import { applyStylizedShading, type LightmapBindings } from '../StylizedShading';

export const BARREL_W = TILE_SIZE * 0.10;
export const BARREL_H = TILE_SIZE * 0.08;
export const BARREL_L = TILE_SIZE * 0.44;

const COLOR = 0x26292f;

const SHADING = {
  lightmapNormalOffset: false,
  keyLightStrength: 0.30,
  rimStrength: 0.55,
  rimPower: 2.5,
  verticalAOStrength: 0.22,
} as const;

const SKIN = {
  panelScale: 0.55, etchStrength: 0.28, ledDensity: 0.05,
  conduitStrength: 0.85, trimHue: 0.10, // flowing amber-gold plasma
} as const;

export interface RobotBarrelPart {
  /** Barrel mesh — the rig parents this under the turret pivot, offset along
   *  local +X so it extends forward from the turret edge. */
  readonly object: THREE.Object3D;
  dispose(): void;
}

/**
 * Procedural barrel box that extends forward from the turret edge. To swap
 * with a Blender model, keep BARREL_L meaningful (the rig offsets the barrel
 * by `TURRET_R + BARREL_L / 2` along local +X) or compensate inside the model
 * by baking the offset into the mesh origin.
 */
export function createRobotBarrel(lightmap: LightmapBindings): RobotBarrelPart {
  const geo = new THREE.BoxGeometry(BARREL_L, BARREL_H, BARREL_W);
  const mat = new THREE.MeshBasicMaterial({ color: COLOR });
  applyStylizedShading(mat, { lightmap, ...SHADING, skin: { seed: 29, ...SKIN } });
  const mesh = new THREE.Mesh(geo, mat);
  return {
    object: mesh,
    dispose: () => { geo.dispose(); mat.dispose(); },
  };
}
